// matches backdropForegroundRGB / backdropBorder in the app's theme
// (src/theme/appTheme.ts) — this used to be the app's pre-redesign
// mainBackground gray (#292929), left behind when the app moved on.
const colors =  {
    backdropBackground: '#1f152d',
    borderBottomColor: '#2E2E2E'
}


export default colors;
